import { getEnvValue } from "./utils";

const appHost = getEnvValue("NEXT_PUBLIC_API_HOST");
const baseUrl = `https://${appHost}`;

const app = Object.freeze({
  protocol: "https",
  host: appHost,
  port: "443",
  baseUrl,
  useProxy: false,
});

export default app;
